import * as React from 'react';
import { useToggle } from '@hooks';
import { Input, InputProps } from '@components/form/input';
import { ButtonIcon } from '@components/button-icon';
import { IconNames } from '@components/icon';

export type PasswordInputProps = Omit<InputProps, 'type' | 'rightContent'>;

const viewPasswordMessage = 'View Password';
const hidePasswordMessage = 'Hide Password';

export const PasswordInput = React.forwardRef(
  (props: InputProps, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
    const { toggle, on: showPassword } = useToggle(true);

    return (
      <Input
        ref={ref}
        {...props}
        rightContent={
          <ButtonIcon
            ariaDescribedby={
              showPassword ? viewPasswordMessage : hidePasswordMessage
            }
            icon={showPassword ? IconNames.EYE : IconNames.EYE_SLASH}
            iconSize={'lg'}
            variant={'text'}
            onClick={() => toggle()}
          >
            <>{showPassword ? viewPasswordMessage : hidePasswordMessage}</>
          </ButtonIcon>
        }
        type={showPassword ? 'password' : 'text'}
      />
    );
  }
);

PasswordInput.displayName = 'PasswordInput';
